// extracted by mini-css-extract-plugin
export var cellStyle = "Cell-module--cellStyle--9PTrn";
export var cellStrain = "Cell-module--cellStrain--PNh8H";